import { find } from 'lodash';
import { createSelector } from 'reselect';
export var getTags = function (state) { var _a; return (_a = state.tags) !== null && _a !== void 0 ? _a : []; };
export var getMostPopularTags = function (state) {
    return state.mostPopularTags;
};
export var getTagBySlug = createSelector([getTags, function (_, tagSlug) { return tagSlug; }], function (tags, tagSlug) { return find(tags, function (tag) { return tag.slug === tagSlug; }); });
